/**
 * @generated SignedSource<<fa07001c45607dcb79b0b2e12f892f9f>>
 * @relayHash 4b1026980a68e088357881501df22fa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 075d5b8b44bb7636a734a8837e67f6d5115f4b1035cdacd9b7888d4d5410d18c

import type { ConcreteRequest } from 'relay-runtime';
export type CcpPricingType = "EXTERNAL" | "FREE" | "LIMITED_FREE" | "PAID" | "%future added value";
export type useCurrentPageTemplateDataTwcEligibilityQuery$variables = {
  cloudIds: ReadonlyArray<string>;
};
export type useCurrentPageTemplateDataTwcEligibilityQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudId: string | null;
    readonly confluenceEntitlementInfo: {
      readonly entitlement?: {
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlement: {
            readonly offering: {
              readonly pricingType: CcpPricingType | null;
            } | null;
          } | null;
          readonly relationshipType: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useCurrentPageTemplateDataTwcEligibilityQuery = {
  response: useCurrentPageTemplateDataTwcEligibilityQuery$data;
  variables: useCurrentPageTemplateDataTwcEligibilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudIds",
    "variableName": "cloudIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v3 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence.ondemand"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v5 = {
  "kind": "ScalarField",
  "name": "pricingType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CcpOffering",
                                "kind": "LinkedField",
                                "name": "offering",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CcpOffering",
                                "kind": "LinkedField",
                                "name": "offering",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4b1026980a68e088357881501df22fa3",
    "id": "075d5b8b44bb7636a734a8837e67f6d5115f4b1035cdacd9b7888d4d5410d18c",
    "metadata": {},
    "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
    "operationKind": "query",
    "text": "query useCurrentPageTemplateDataTwcEligibilityQuery($cloudIds:[ID!]!){tenantContexts(cloudIds:$cloudIds){cloudId,confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements{relationshipType,entitlement{offering{pricingType,id},id}},id}}}}}"
  }
};
})();

(node as any).hash = "81287ad3bd8f10fbf0ab317d19c1d49e";

export default node;
